import React from "react";
import { useReveal } from "../lib/useReveal";

const PILLARS = [
  {
    title: "Memory is contested.",
    body: "Holidays are not neutral. They reflect choices about whose stories are taught in classrooms, named in legislation, paid for with public funds, and protected from political interference.",
  },
  {
    title: "Recognition is not the finish line.",
    body: "A federal holiday or heritage month does not automatically secure a community's safety, voice, or place in the historical record. Recognition makes erasure harder — it does not make it impossible.",
  },
  {
    title: "Erasure is rarely loud.",
    body: "It looks like underfunded archives, banned books, dropped curricula, renamed monuments, and quiet decisions to skip a date because it feels inconvenient or partisan to mention.",
  },
  {
    title: "A democracy that forgets its debts loses its authority.",
    body: "Marking these dates honestly is part of how a country keeps faith with everyone whose labor, suffering, and victories built the institutions we share now.",
  },
];

export const WhyItMatters = () => {
  const ref = useReveal();
  return (
    <section id="why" className="section reveal" ref={ref} data-testid="why-section" style={{
      background: "hsl(var(--bg-deep))",
      borderTop: "1px solid hsl(var(--line))",
      borderBottom: "1px solid hsl(var(--line))",
    }}>
      <div className="shell">
        <span className="section__eyebrow">Why these dates matter</span>
        <h2 style={{ maxWidth: 18 + "ch" }}>
          Public memory is a public infrastructure.
        </h2>
        <p className="section__lede" style={{ marginTop: "1rem" }}>
          The dates a country chooses to remember — and how it remembers them — shape what people
          believe is possible, who they think they owe, and how they tell the truth about the past.
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "1.5rem",
          marginTop: "3rem",
        }}>
          {PILLARS.map((p, idx) => (
            <article key={p.title} style={{
              padding: "1.6rem",
              border: "1px solid hsl(var(--line))",
              background: "hsl(var(--bg))",
              position: "relative",
            }}>
              <span
                className="archival-figure"
                aria-hidden
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "0.85rem",
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: "hsl(var(--accent))",
                  marginBottom: 12,
                  display: "block",
                }}
              >
                {String(idx + 1).padStart(2, "0")}
              </span>
              <h3 style={{
                fontFamily: "var(--font-display)",
                fontSize: "1.3rem",
                fontWeight: 500,
                marginTop: 0,
                marginBottom: 8,
                lineHeight: 1.2,
              }}>
                {p.title}
              </h3>
              <p style={{ fontSize: "0.95rem", lineHeight: 1.6, margin: 0 }}>
                {p.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
